import React from 'react'
import SchoolIcon from '@mui/icons-material/School';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import './Education.css'
import ApartmentIcon from '@mui/icons-material/Apartment';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
const Education = () => {
  return (
    <>
      <h2 className="section-title">Education</h2>
      <div className='section-education'>
        <VerticalTimeline contentStyle={{ width: '66%' }} >
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'rgba(255, 255, 255, 0.14)', color: '#fff', backdropFilter: 'blur(5.1px)' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="2024 - 2026"
            iconStyle={{ background: 'black', color: '#fff' }}
            icon={<AccountBalanceIcon />}
          >
            <h3 className="vertical-timeline-element-title">National Institute Of Technology, Durgapur</h3>
            <h4 className="vertical-timeline-element-subtitle">Durgapur, West Bengal</h4>
            <p>
              Masters In Technology in  Computer Science and Engineering
            </p>
            {/* <p>CGPA - 8.72</p> */}
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'rgba(255, 255, 255, 0.14)', color: '#fff', backdropFilter: 'blur(5.1px)' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="2020 - 2024"
            iconStyle={{ background: 'black', color: '#fff' }}
            icon={<AccountBalanceIcon />}
          >
            <h3 className="vertical-timeline-element-title">Veer Surendra Sai University Of Technology</h3>
            <h4 className="vertical-timeline-element-subtitle">Burla, Sambalpur</h4>
            <p>
              Bachelor In Technology in  Information Technology
            </p>
            <p>CGPA - 8.81</p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2018 - 2020"
            contentStyle={{ background: 'rgba(255, 255, 255, 0.14)', color: '#fff', backdropFilter: 'blur(5.1px)' }}
            iconStyle={{ background: 'black', color: '#fff' }}
            icon={<ApartmentIcon />}
          >
            <h3 className="vertical-timeline-element-title">D.A.V Public School</h3>
            <h4 className="vertical-timeline-element-subtitle">Berhampur</h4>
            <p>
              Intermediate
            </p>
            <p>Marks Secured - 94.4%</p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2018"
            contentStyle={{ background: 'rgba(255, 255, 255, 0.14)', color: '#fff', backdropFilter: 'blur(5.1px)' }}
            iconStyle={{ background: 'black', color: '#fff' }}
            icon={<SchoolIcon />}
          >
            <h3 className="vertical-timeline-element-title">Harobino Vidya Bhavan </h3>
            <h4 className="vertical-timeline-element-subtitle">Berhampur</h4>
            <p>
              Matriculation
            </p>
            <p>Marks Secured - 93.4%</p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </>
  )
}

export default Education
